import { Card, List, Skeleton } from 'antd'
import React from 'react'

const CommonSkeletonLoader = ({ itemCount = 3, showAvatar = false, avatarSize = 64 }) => {
    const placeholderData = Array.from({ length: itemCount }, (_, index) => ({ key: index }));

    return (
        <List
            dataSource={placeholderData}
            renderItem={(item) => (
                <List.Item key={item.key} style={{borderBottomColor: 'transparent'}}>
                    <Card style={{ width: '100%' }}  bordered={false}>
                        <Skeleton
                            active
                            avatar={showAvatar ? { size: avatarSize, shape: 'circle' } : false}
                            paragraph={{ rows: 2, width: ['100%', '80%'] }}
                        />
                    </Card>
                </List.Item>
            )}
        />
    )
}

export default CommonSkeletonLoader